import type { UnknownRecord } from "@/utils/type";

export class ApplicationError extends Error {
  constructor(
    public override name: string,
    message: string,
    public contexts: Contexts,
  ) {
    super(message);
  }
}

type Contexts = Record<string, UnknownRecord>;
